import React, { useContext } from 'react'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import styled, { ThemeContext } from 'styled-components'
import { lighten } from 'polished';

import queryString from 'qs'
import flowRight from 'lodash/flowRight'

import Button from 'shared/components/Button'
import Box from 'shared/components/Box'

import useQuery from 'shared/hooks/useQuery'

import { UserRoleTypeWithStatus } from 'pages/UserRole/model/role'
import { NoteType } from 'shared/components/Notes/models/note'
import { NoteCardHeader } from 'shared/components/Notes'

type Props = WrappedProps<NoteType> & {
  description?: string
  closeButton?: boolean
  commentButton?: boolean
}

function BasicDialog(props: Props) {
  const {
    formState,
    formHandlers,
    onClose,
    onContinue,
    description,
    closeButton = false,
    commentButton = false
  } = props

  const { fields, errors } = formState
  const { onElementChange, onChange } = formHandlers
  const theme = useContext(ThemeContext)

  return (
    <BasicDialogBodyContainer className="confirm-dialog-container">
      {description && (
        <Box className="description">{description}</Box>
      )}
      {commentButton && (
        <StyledButton
          variant="primary"
          onClick={onContinue}
          width="180px"
        >
          Add Comment
        </StyledButton>
      )}
      {closeButton && (
        <StyledButton
          variant="primary"
          onClick={onClose}
          width="110px"
        >
          Close
        </StyledButton>
      )}
      {!closeButton && (
        <div className="dialog-button-close" onClick={onClose}>Cancel</div>
      )}
    </BasicDialogBodyContainer>
  )
}

const WrappedBasicDialog = flowRight(withDialog())(BasicDialog)


const StyledButton = styled(Button)`
  margin: 40px auto 0;
`


const BasicDialogBodyContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  .dialog-button-close {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;

    color: ${({ theme }) => theme?.colors?.main};
    text-decoration-line: underline;
    text-align: center;
    cursor: pointer;

    width: fit-content;
    margin: 40px auto 0;
  }

  .note-content {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    color: ${({ theme }) => theme?.colors?.secondary};

    margin-top: 1.5rem;
  }
`

WrappedBasicDialog.defaultProps = {
  // continueIsDisabled(data: NoteType) {
  //   return !data?.message?.length
  // },
}

export default WrappedBasicDialog
